export default __webpack_public_path__ + "static/media/power_supply.f1d49080.svg";